// @flow

import { SPECIALTIES } from '../actions/specialties';

const initialState = {
  mainSpecialties: new Map(),
  mainSpecialtiesState: undefined,
  subSpecialties: new Map(),
  subSpecialtiesState: undefined,
};

export default (state: Object = initialState, { type, ...payload }: Object) => {
  switch (type) {
    case SPECIALTIES.MAIN_SPECIALTIES.LOADING: {
      return {
        ...state,
        mainSpecialtiesState: SPECIALTIES.MAIN_SPECIALTIES.LOADING,
      };
    }

    case SPECIALTIES.MAIN_SPECIALTIES.SUCCEEDED: {
      const mainSpecialties = new Map();

      if (payload.mainSpecialties) {
        payload.mainSpecialties.forEach(mainSpecialty => {
          mainSpecialties.set(mainSpecialty.SpecialityKey, mainSpecialty);
        });
      }

      return {
        ...state,
        mainSpecialties,
        mainSpecialtiesState: SPECIALTIES.MAIN_SPECIALTIES.SUCCEEDED,
      };
    }

    case SPECIALTIES.MAIN_SPECIALTIES.FAILED: {
      return {
        ...state,
        mainSpecialties: new Map(),
        mainSpecialtiesState: SPECIALTIES.MAIN_SPECIALTIES.FAILED,
      };
    }

    case SPECIALTIES.SUB_SPECIALTIES.LOADING: {
      return {
        ...state,
        subSpecialtiesState: SPECIALTIES.SUB_SPECIALTIES.LOADING,
      };
    }

    case SPECIALTIES.SUB_SPECIALTIES.SUCCEEDED: {
      const subSpecialties = new Map();

      if (payload.subSpecialties) {
        payload.subSpecialties.forEach(subSpecialty => {
          subSpecialties.set(subSpecialty.SpecialityKey, subSpecialty);
        });
      }

      return {
        ...state,
        subSpecialties,
        subSpecialtiesState: SPECIALTIES.SUB_SPECIALTIES.SUCCEEDED,
      };
    }

    case SPECIALTIES.SUB_SPECIALTIES.FAILED: {
      return {
        ...state,
        subSpecialties: new Map(),
        subSpecialtiesState: SPECIALTIES.SUB_SPECIALTIES.FAILED,
      };
    }

    default: {
      return state;
    }
  }
};
